import * as path from 'path'
import * as os from 'os'
import * as fs from 'fs'
import { KV } from 'yam-types'
import * as _ from 'lodash'

const HOME_DIR = os.homedir()
export const COMMON_CACHE_PATH = path.join(HOME_DIR, '.yam', 'engine-cache.json')

const cacheSyncPeriod = 100
const fSync = _.debounce(() => {
  fs.writeFileSync(COMMON_CACHE_PATH, JSON.stringify(cacheObj))
}, cacheSyncPeriod)

// Object acts as KV cache, for serializing JSON
let cacheObj = {} as KV

if (fs.existsSync(COMMON_CACHE_PATH)) {
  const buf = fs.readFileSync(COMMON_CACHE_PATH)
  if (buf.length > 0) {
    cacheObj = JSON.parse(buf.toString())
  }
} else {
  const dir = path.join(HOME_DIR, '.yam')
  if (!fs.existsSync(dir)) {
    fs.mkdirSync(dir)
  }
}

export function cacheGet<T>(key: string): T | undefined {
  return cacheObj[key] as T | undefined
}

export function cacheSet<T>(key: string, value: T): void {
  cacheObj[key] = value
  fSync()
}

export function cacheDelete(key: string): void {
  delete cacheObj[key]
  fSync()
}